module.exports = __webpack_public_path__ + "jug.jpg?a5594f1ebf1c96357d88e65292605159";